export default function dataDelete(way,index){


    this.dataArrayDelete([{way:way,index:index}])

}